module.exports = __webpack_public_path__ + "img/ico1.72ced763.png";